/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  CardPaymentRequestDto,
  CardPaymentResponseDto,
  PaymentScheduleDetails,
  PaymentSessionResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Make card payment
 */
export const makeCardPayment = (
  cardPaymentRequestDto: CardPaymentRequestDto,
  options?: SecondParameter<typeof backofficeRequest<CardPaymentResponseDto>>,
) => {
  return backofficeRequest<CardPaymentResponseDto>(
    {
      url: `/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardPaymentRequestDto,
    },
    options,
  )
}
/**
 * @summary Create a flow payment session
 */
export const createPaymentSession = (
  cardPaymentRequestDto: CardPaymentRequestDto,
  options?: SecondParameter<typeof backofficeRequest<PaymentSessionResponse>>,
) => {
  return backofficeRequest<PaymentSessionResponse>(
    {
      url: `/api/v2/payments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardPaymentRequestDto,
    },
    options,
  )
}
/**
 * @summary Get all paymentSchedules for an account.
 */
export const getPaymentScheduleDetails = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<PaymentScheduleDetails>>,
) => {
  return backofficeRequest<PaymentScheduleDetails>(
    {
      url: `/api/v1/accounts/${billingAccountId}/paymentScheduleDetails`,
      method: "GET",
    },
    options,
  )
}
export type MakeCardPaymentResult = NonNullable<
  Awaited<ReturnType<typeof makeCardPayment>>
>
export type CreatePaymentSessionResult = NonNullable<
  Awaited<ReturnType<typeof createPaymentSession>>
>
export type GetPaymentScheduleDetailsResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentScheduleDetails>>
>
